/**
 * Plain-text summary of a lesson section for Image Studio's "Suggest prompt",
 * which drafts an image prompt from the section the image will be added to.
 * Works for every section type: text/rich_text keep their words in `content`
 * and `subsections`, cards/flashcards/lists in `items`.
 */
export const MAX_SECTION_CONTEXT = 1200;

// Fields that hold readable lesson text (never URLs, ids or image payloads).
const TEXT_KEYS = ['title', 'text', 'content', 'front', 'back', 'question', 'answer', 'description', 'term', 'definition', 'example'];

function collect(value, out, depth = 0) {
  if (value == null || depth > 3) return;
  if (typeof value === 'string') {
    const t = value.trim();
    if (t && !/^(data:|https?:\/\/)/i.test(t)) out.push(t);
    return;
  }
  if (Array.isArray(value)) { value.forEach((v) => collect(v, out, depth + 1)); return; }
  if (typeof value === 'object') TEXT_KEYS.forEach((k) => collect(value[k], out, depth + 1));
}

/** @param {object} section  a framework section */
export function sectionImageContext(section) {
  if (!section || typeof section !== 'object') return '';
  const parts = [];
  if (section.title) parts.push(`Section: ${String(section.title).trim()}`);
  [section.content, section.subsections, section.items, section.objectives, section.takeaways]
    .forEach((v) => collect(v, parts));
  return parts.join('\n').replace(/[ \t]+/g, ' ').slice(0, MAX_SECTION_CONTEXT).trim();
}
